// Mock payment data for demonstration
export const mockPaymentData = [
  {
    id: 1,
    studentId: 'S001',
    studentName: '張小明',
    class: '6A',
    item: '學費',
    amount: 5000,
    dueDate: '2024-01-31',
    status: 'paid',
    paymentDate: '2024-01-15',
    paymentMethod: '銀行轉帳',
    reference: 'TXN001',
    notes: 'First semester tuition'
  },
  {
    id: 2,
    studentId: 'S001',
    studentName: '張小明',
    class: '6A',
    item: '課外活動費',
    amount: 800,
    dueDate: '2024-02-15',
    status: 'pending',
    paymentDate: null,
    paymentMethod: null,
    reference: null,
    notes: 'ECA fee for swimming class'
  },
  {
    id: 3,
    studentId: 'S002',
    studentName: '李小華',
    class: '6A',
    item: '學費',
    amount: 5000,
    dueDate: '2024-01-31',
    status: 'paid',
    paymentDate: '2024-01-20',
    paymentMethod: '現金',
    reference: 'TXN002',
    notes: 'First semester tuition'
  },
  {
    id: 4,
    studentId: 'S002',
    studentName: '李小華',
    class: '6A',
    item: '課外活動費',
    amount: 600,
    dueDate: '2024-02-15',
    status: 'paid',
    paymentDate: '2024-01-25',
    paymentMethod: '支票',
    reference: 'TXN003',
    notes: 'ECA fee for art class'
  },
  {
    id: 5,
    studentId: 'S003',
    studentName: '王小美',
    class: '6A',
    item: '學費',
    amount: 5000,
    dueDate: '2024-01-31',
    status: 'overdue',
    paymentDate: null,
    paymentMethod: null,
    reference: null,
    notes: 'First semester tuition - overdue'
  },
  {
    id: 6,
    studentId: 'S003',
    studentName: '王小美',
    class: '6A',
    item: '課外活動費',
    amount: 700,
    dueDate: '2024-02-15',
    status: 'pending',
    paymentDate: null,
    paymentMethod: null,
    reference: null,
    notes: 'ECA fee for music class'
  },
  {
    id: 7,
    studentId: 'S004',
    studentName: '陳小強',
    class: '6A',
    item: '學費',
    amount: 5000,
    dueDate: '2024-01-31',
    status: 'paid',
    paymentDate: '2024-01-18',
    paymentMethod: '銀行轉帳',
    reference: 'TXN004',
    notes: 'First semester tuition'
  },
  {
    id: 8,
    studentId: 'S004',
    studentName: '陳小強',
    class: '6A',
    item: '課外活動費',
    amount: 900,
    dueDate: '2024-02-15',
    status: 'pending',
    paymentDate: null,
    paymentMethod: null,
    reference: null,
    notes: 'ECA fee for sports class'
  },
  {
    id: 9,
    studentId: 'S005',
    studentName: '劉小芳',
    class: '6A',
    item: '學費',
    amount: 5000,
    dueDate: '2024-01-31',
    status: 'paid',
    paymentDate: '2024-01-22',
    paymentMethod: '現金',
    reference: 'TXN005',
    notes: 'First semester tuition'
  },
  {
    id: 10,
    studentId: 'S005',
    studentName: '劉小芳',
    class: '6A',
    item: '課外活動費',
    amount: 750,
    dueDate: '2024-02-15',
    status: 'paid',
    paymentDate: '2024-01-28',
    paymentMethod: '銀行轉帳',
    reference: 'TXN006',
    notes: 'ECA fee for dance class'
  }
];

// Helper function to get payment data by student
export const getPaymentByStudent = (studentId) => {
  return mockPaymentData.filter(payment => payment.studentId === studentId);
};

// Helper function to get payment data by status
export const getPaymentByStatus = (status) => {
  return mockPaymentData.filter(payment => payment.status === status);
};

// Helper function to get payment data by date range
export const getPaymentByDateRange = (startDate, endDate) => {
  return mockPaymentData.filter(payment => {
    if (payment.paymentDate) {
      const paymentDate = new Date(payment.paymentDate);
      return paymentDate >= new Date(startDate) && paymentDate <= new Date(endDate);
    }
    return false;
  });
};
